'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var R = require('ramda');

/**
 * Combine several middlewares into one.
 * @param {Array<Function>} middlewares
 * @return {Function}
 */

function combineMiddleware(middlewares) {
  return function (store) {
    return function (next) {
      return R.reduceRight(function (middleware, next) {
        return middleware(store)(next);
      }, next, middlewares);
    };
  };
}

exports.combineMiddleware = combineMiddleware;
//# sourceMappingURL=combine-middleware.js.map
